import { Route, Navigate, Routes } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { routes, MD } from '../../config/constants';
import { useMediaQuery } from 'react-responsive';
import Check from './containers/Check';
import History from './containers/History';
import AsidePanel from './components/AsidePanel';
import CommonLayout from './components/CommonLayout';
import { mobileAndTabletCheck } from '../../lib/utils';
import DownloadButton from './containers/History/components/DownloadButton';
import ScrollToTop from '../routes/scroll-to-top';

const Room = () => {
    const [asidePanelIsShow, toggleAsidePanel] = useState(false);
    const isPhoneOrTablet = useMediaQuery({ query: `(max-width: ${MD}px)` }) && mobileAndTabletCheck();

    useEffect(() => {
        document.documentElement.style.overflow = asidePanelIsShow ? 'hidden' : '';
        return () => {
            document.documentElement.style.overflow = '';
        };
    }, [asidePanelIsShow]);

    function hideAsidePanel() {
        if (asidePanelIsShow) {
            toggleAsidePanel(false);
        }
    }

    function showAsidePanel() {
        if (!asidePanelIsShow) {
            toggleAsidePanel(true);
        }
    }

    return (
        <div className="room-layout">
            <AsidePanel asidePanelIsShow={asidePanelIsShow} hideAsidePanel={hideAsidePanel} />
            <ScrollToTop />
            <Routes>
                <Route
                    path={routes.roomTickets}
                    element={
                        <CommonLayout
                            showAsidePanel={showAsidePanel}
                            title={isPhoneOrTablet ? 'Сканирование' : 'Ввести номер билета'}
                            reverseColors={isPhoneOrTablet}
                        >
                            <Check />
                        </CommonLayout>
                    }
                />
                <Route
                    path={routes.roomHistory}
                    element={
                        <CommonLayout
                            showAsidePanel={showAsidePanel}
                            title="История"
                            HeaderRightButton={DownloadButton}
                            hideHeaderBorder={true}
                        >
                            <History />
                        </CommonLayout>
                    }
                />
                <Route path="*" element={<Navigate replace to={routes.roomTickets} />} />
            </Routes>
        </div>
    );
};

export default Room;
